import { Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer className="glass-card border-t border-white/10 py-12 px-6 md:px-12 lg:px-24 mt-10">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Brand & Positioning */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex items-center gap-1">
                <span className="text-xl font-extrabold bg-gradient-to-r from-pink-500 to-rose-500 bg-clip-text text-transparent">UP</span>
                <span className="text-xl font-extrabold text-foreground">NEXT</span>
              </div>
            </div>
            
            {/* Differentiation Statement */}
            <p className="text-foreground text-sm font-medium mb-2">
              Bukan media. Bukan ticketing. Ini planning tool.
            </p>
            <p className="text-muted-foreground text-sm max-w-md mb-4">
              UP NEXT CALENDAR dibina untuk orang Malaysia yang tak nak buang masa decide. Semua event, satu tempat.
            </p>
            
            {/* Trust Signal */}
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <AlertCircle className="h-3 w-3" />
              <span>Info dikumpul dari sumber rasmi & komuniti. <a href="/about" className="text-pink-400 hover:underline">Ada info salah? Report sini.</a></span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-foreground text-sm">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-muted-foreground hover:text-pink-400 text-sm transition-colors">Home</a></li>
              <li><a href="/events" className="text-muted-foreground hover:text-pink-400 text-sm transition-colors">Events</a></li>
              <li><a href="/calendar" className="text-muted-foreground hover:text-pink-400 text-sm transition-colors">Calendar</a></li>
              <li><a href="/tools" className="text-muted-foreground hover:text-pink-400 text-sm transition-colors">Planning Tools</a></li>
              <li><a href="/free-events" className="text-muted-foreground hover:text-pink-400 text-sm transition-colors">Free Events</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-xs">
            © 2026 UP NEXT CALENDAR Malaysia. Visit Malaysia Year 2026.
          </p>
          <p className="text-muted-foreground text-xs text-center md:text-right">
            "Nak buat apa weekend ni?" — Jawapan ada di sini.
          </p>
        </div>
      </div>
    </footer>
  );
}
